export default [{
    path: 'customTj',
    name: {list:['数字供销','统计','统计分析','用户分析'],title:'用户分析'},
    type:['developement'],   //'developement','test','production'  开发 测试 生产
    component: () => import('@/views/statisticsFolder/customTj.vue')
  },{
    path: 'goodsTj',
    name: {list:['数字供销','统计','统计分析','商品统计'],title:'商品统计'},
    type:['developement'],   //'developement','test','production'  开发 测试 生产
    component: () => import('@/views/statisticsFolder/goodsTj.vue')
  },
]